<template>
  <section>
  <div>
    <!-- loading circle -->
  </div>
  <div class="dropdown" @mouseleave="handleMouseLeave">
    <button class="dropdown-toggle" :style="{backgroundColor:background, height:btnHeight}" :disabled="disabled" @click="showDropdown = !showDropdown">
      {{ label }}
    </button>
    <div class="dropdown-content" v-show="showDropdown && !disabled">
      <input
        type="text"
        v-model="search"
        placeholder="Search..."
        :disabled="disabled"
        @input="filterOptions"
      />
      <label class="flex v-center gap-1 mt-3" :class="{ disabled: disabled || disableOption }">
        <input class="" type="checkbox" :disabled="disabled || disableOption" @click="selectAll" /> <span>Select All</span>
      </label>
      <label v-for="(option, index) in options" :key="index" class=" flex v-center gap-1" :class="{ disabled: disabled || disableOption }">
        <input
          type="checkbox"
          class="option"
          :value="option.value"
          :data-label="option.label"
          :disabled="disabled || disableOption"
          v-model="selectedOptions"
        />
       <div class="option-label elipsis-text" v-overflow-tooltip> {{ option.label }}</div>
      </label>
    </div>
    <div v-if="selectedOptions.length" class="selectedCount">
      {{ selectedOptions.length }}
    </div>
  </div>
</section>
</template>

<script>
export default {
  name: 'multiSelectDropdown',
  props: {
    width: {
      type: String,
      default: '200px'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disableOption: {
      type: Boolean,
      default: false
    },
    initiallySelected: Array,
    options: Array,
    label: {
      type: String,
      default: 'Select Options'
    },
    background: {
      type: String,
      default: 'var(--brand-light-color)'
    },
    btnHeight: {
      type: String,
      default: '40px'
    }

  },
  data () {
    return {
      search: '',
      selectedOptions: [],
      showDropdown: false
    }
  },
  mounted () {
    if (this.initiallySelected) {
      this.selectedOptions = this.initiallySelected
    } else { this.selectedOptions = [] }
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    handleMouseLeave () {
      this.$emit('selected', this.selectedOptions)
    },
    handleClickOutside (event) {
      if (!this.$el.contains(event.target)) {
        this.emitSelected()
      }
    },
    emitSelected () {
      if (this.showDropdown && !this.disabled) { // showdropdown is there means to prevent false emiting of data
        this.$emit('selected', this.selectedOptions)
      }
      this.showDropdown = false
    },
    filterOptions () {
      if (this.disabled) return
      const filter = this.search.toUpperCase()
      const options = this.$el.querySelectorAll('.option')
      options.forEach((option) => {
        const text = option.dataset.label
        option.parentElement.style.display =
          text.toUpperCase().indexOf(filter) > -1 ? 'flex' : 'none'
      })
    },
    selectAll () {
      if (this.disabled || this.disableOption) return
      const selectAllCheckbox = this.$el.querySelector(
        ".dropdown-content input[type='checkbox']:first-child"
      )
      this.selectedOptions = selectAllCheckbox.checked
        ? this.options.map((opt) => opt.value)
        : []
    }
  },
  watch: {
    selectedOptions () {
      const selectAllCheckbox = this.$el.querySelector(
        ".dropdown-content input[type='checkbox']:first-child"
      )
      if (selectAllCheckbox) {
        selectAllCheckbox.checked =
        this.selectedOptions?.length === this.options?.length && this.selectedOptions?.length > 0
      }
    },
    options () {
      // this.selectedOptions = []
    },
    initiallySelected (newVal, oldVal) {
      this.selectedOptions = [...newVal]
      this.search = ''
    },
    showDropdown () {
      if (this.showDropdown && this.search && !this.disabled) {
        this.filterOptions()
      }
    }
  }
}
</script>

  <style lang="scss" scoped>
/* Add your CSS styles here */
.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-toggle {
  background-color: var(--brand-light-color);
  border: 1px solid var(--brand-color);
  // padding: 8px 12px;
  cursor: pointer;
  width: v-bind(width);
  border-radius: 0.3em;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    background-color: #f5f5f5;
  }
}

.dropdown-content {
  position: absolute;
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 0.1em 0.1em 0.1em rgba(0, 0, 0, 0.25);
  padding: 8px;
  z-index: 2;
  width: 200px;
  max-height: 365px;
  overflow-x: hidden;
  overflow-y: auto;
 & input[type="text"] {
    padding: 4px;
    border-radius: 4px;
    border-color: rgb(30, 27, 27,.3);
    border-style: solid;
    width: calc(100% - 8px);
    box-sizing: border-box;
    font-size: var(--text-m);
  }
  & input:focus{
    border-color: rgb(30, 27, 27,.7);
    border-style: solid;
  }
}

.dropdown-content label {
  margin-bottom: 5px;

  &.disabled {
    opacity: 0.6;

    input[type="checkbox"] {
    }

    .option-label {
    }
  }
}

.selectedCount {
  border-radius: 50%;
  position: absolute;
  top: -4px;
  padding: 3px 10px;
  background: var(--brand-color);
  right: -9px;
}

#searchInput {
  width: 100%;
  padding: 8px;
  margin-bottom: 8px;
}
.option-label{
flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
